import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/clusterEbox/importer/clusterEboxImporterActions';

export default importerReducers(actions);
